import React from "react"

const Google = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.32 14.2917C26.32 13.3817 26.2383 12.5067 26.0867 11.6667H14V16.6309H20.9067C20.6092 18.2351 19.705 19.5942 18.3458 20.5042V23.7242H22.4933C24.92 21.4901 26.32 18.2001 26.32 14.2917Z"
        fill="#4285F4"
      />
      <path
        d="M13.9996 26.8332C17.4646 26.8332 20.3696 25.6841 22.4929 23.7241L18.3454 20.5041C17.1963 21.2741 15.7263 21.7291 13.9996 21.7291C10.6571 21.7291 7.82792 19.4716 6.81875 16.4382H2.53125V19.7632C4.64292 23.9574 8.98292 26.8332 13.9996 26.8332Z"
        fill="#34A853"
      />
      <path
        d="M6.82047 16.4382C6.5638 15.6682 6.41797 14.8457 6.41797 13.9999C6.41797 13.1541 6.5638 12.3316 6.82047 11.5616V8.23657H2.53297C1.63464 10.0249 1.16718 11.9986 1.16797 13.9999C1.16797 16.0707 1.6638 18.0307 2.53297 19.7632L6.82047 16.4382Z"
        fill="#FBBC05"
      />
      <path
        d="M13.9996 6.27092C15.8837 6.27092 17.5754 6.91842 18.9054 8.19008L22.5863 4.50925C20.3638 2.43841 17.4587 1.16675 13.9996 1.16675C8.98292 1.16675 4.64292 4.04258 2.53125 8.23675L6.81875 11.5617C7.82792 8.52842 10.6571 6.27092 13.9996 6.27092Z"
        fill="#EA4335"
      />
    </svg>
  )
}

export default Google
